import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  constructor(private _http : HttpClient) { }

  getAppConfigs(): Observable<any> {
      const url = `api/app-configs/all`;
      return this._http.get(url); 
  }
}
